module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (173).300c7599.jpg";